<div ngbDropdown placement="bottom-right" class="kt-header__topbar-item kt-header__topbar-item--user" *ngIf="loaded">
	<div ngbDropdownToggle class="kt-header__topbar-wrapper">
		<!--begin::Topbar Mobile Toggle-->
		<button class="btn btn-hover-text-primary p-0 ml-2">
			<span [inlineSVG]="'./assets/media/svg/icons/General/User.svg'" class="svg-icon svg-icon-xl"></span>
		</button>
		<!--end::Topbar Mobile Toggle-->
		<!-- <span class="kt-header__topbar-icon"><b>{{_user.fullname|firstLetter}}</b></span> -->
	</div>
	<div ngbDropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-sm">
		<div class="p-4">
			<!--begin: Head -->
			<div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x d-flex w-60">
				<span class="symbol symbol-35 symbol-light-success">
					<span class="symbol-label font-size-h5 font-weight-bold">{{fullname|firstLetter}}</span>
				</span>
				<div class="kt-user-card__name pl-4 pr-1">
					<a href="#" class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary">
						{{fullname}}
					</a>
					<div class="text-muted mt-1">{{role}}</div>
					<a (click)="logout()" class="btn btn-light-primary btn-bold">
						Cerrar sesión
					</a>
				</div>
			</div>
			<!--end: Head -->
		</div>
	</div>
</div>